import { Button, Col, Row } from "antd";
import React from "react";

const ShowAnswerSheet = ({
  currentQuestionIndex,
  setCurrentQuestionIndex,
  listOfQuestion,
  userAnswers,
  handleSelectAnswer,
  remainingTime,
  questionComplete,
}) => {
  const alphabetLabel = (index) => String.fromCharCode(65 + index) + ".";

  const formatTime = (seconds) => {
    const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${mins}:${secs}`;
  };

  return (
    <Row style={{ margin: 20 }}>
      <Col span={24}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 0",
            borderRadius: 8,
          }}
        >
          <p style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>
            {`Question ${currentQuestionIndex + 1} of ${
              listOfQuestion.results.length
            }`}
          </p>
          <p
            style={{
              fontSize: 18,
              fontWeight: "bold",
              color: remainingTime < 60 ? "red" : "#333", // đỏ khi < 1 phút
              margin: 0,
            }}
          >
            ⏳ {formatTime(remainingTime)}
          </p>
          <p style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>
            {/* {Math.round(
                ((currentQuestionIndex + 1) / listOfQuestion.results.length) *
                  100
              )} */}
            {Math.round(
              (questionComplete / listOfQuestion.results.length) * 100
            )}
            % Complete
          </p>
        </div>
      </Col>

      <Col span={24} style={{ marginTop: 20 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* Nút Quay lại */}
          <Button
            type="primary"
            onClick={() => {
              if (currentQuestionIndex > 0) {
                setCurrentQuestionIndex(currentQuestionIndex - 1);
              }
            }}
            disabled={currentQuestionIndex === 0}
          >
            Quay lại
          </Button>

          <Button
            type="primary"
            onClick={() => {
              setCurrentQuestionIndex(currentQuestionIndex + 1);
            }}
            disabled={
              currentQuestionIndex === listOfQuestion.results.length - 1
            }
          >
            Câu tiếp theo
          </Button>
        </div>

        {/* Tiêu đề câu hỏi */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "18px 16px",
            borderRadius: 8,
            backgroundColor: "#f5f5f5",
            marginTop: 20,
            userSelect: "none",
          }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <p
            style={{
              fontSize: 22,
              fontWeight: 600,
              margin: 0,
            }}
          >
            {currentQuestionIndex + 1}/{" "}
            {listOfQuestion?.results[currentQuestionIndex].cau_hoi}
          </p>
        </div>

        {/* Các đáp án */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            marginTop: 20,
          }}
        >
          {listOfQuestion?.results[currentQuestionIndex].dap_an.map(
            (answer, idx) => {
              const currentQuestionId =
                listOfQuestion.results[currentQuestionIndex].id.toString();

              const selectedAnswerRaw = userAnswers.find(
                (a) => a.id === currentQuestionId
              )?.dap_an;

              const isSelected = selectedAnswerRaw
                ?.split("+")
                .includes((idx + 1).toString());

              return (
                <div
                  key={idx}
                  onClick={() => handleSelectAnswer(currentQuestionIndex, idx)}
                  onContextMenu={(e) => e.preventDefault()}
                  style={{
                    userSelect: "none",
                    width:
                      listOfQuestion.results[currentQuestionIndex].dap_an
                        .length === 1
                        ? "100%"
                        : "calc(50% - 8px)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "18px 16px",
                    borderRadius: 8,
                    backgroundColor: isSelected ? "#ecf5ff" : "#f5f5f5",
                    minHeight: 80,
                    fontSize: 15,
                    cursor: "pointer",
                    border: isSelected
                      ? "1px solid #0096c7"
                      : "1px solid transparent",
                    transition: "all 0.3s",
                  }}
                >
                  <p
                    style={{
                      fontSize: 16,
                      fontWeight: 500,
                      margin: 0,
                    }}
                  >
                    {alphabetLabel(idx)} {answer}
                  </p>
                </div>
              );
            }
          )}
        </div>
      </Col>
    </Row>
  );
};

export default ShowAnswerSheet;
